import React, {useEffect, useState, useRef} from 'react'
import localforage from "localforage";
import logo_sm from "../institutions/layouts/logo-sm.png";
import {Link} from "react-router-dom";

const PatientDashboardHeader: React.FC = () => {

    const [fname, setFname] = useState<any>("")
    const [lname, setLname] = useState<any>("")
    const [clinicName, setClinicName] = useState<any>("")
    const [staffId, setStaffId] = useState<any>("")
    const [avatar, setAvatar] = useState<any>("avatar.png")
    const [wallet, setWallet] = useState<any>(0)
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [notifOpen, setNotifOpen] = useState(false);
    const [profileOpen, setProfileOpen] = useState(false);
    const notifRef = useRef<HTMLDivElement>(null);
    const profileRef = useRef<HTMLDivElement>(null);

    const toggleFullscreen = () => {
        if (!isFullscreen) {
            document.documentElement.requestFullscreen();
        } else {

            document.exitFullscreen();
        }

        setIsFullscreen(!isFullscreen);

    }




    useEffect(()=>{


        localforage.getItem("fname").then((first_name)=>{
            setFname(first_name)
        })

        localforage.getItem("lname").then((last_name)=>{
            setLname(last_name)
        })

        localforage.getItem("clinic_name").then((clinic)=>{
            setClinicName(clinic)
        })

        localforage.getItem("staff_id").then((usr)=>{
            setStaffId(usr)
        })

        localforage.getItem("user_avatar").then((avtr)=>{
            if(avtr === "" || avtr === null){
                setAvatar("avatar.png")
            }else{

                setAvatar(avtr)
            }
        })

        const handleClick = (e: MouseEvent) => {
            if (notifRef.current && !notifRef.current.contains(e.target as Node)) setNotifOpen(false);
            if (profileRef.current && !profileRef.current.contains(e.target as Node)) setProfileOpen(false);
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);

    }, [])

    return(
        <div className="flex items-center justify-between px-6 py-4 bg-white rounded-none shadow-md">
            {/* Left: Logo/Brand */}
            <div className="flex items-center gap-4">
                <img src={`${process.env.PUBLIC_URL}/assets/images/uzima-logo-sm.svg`} alt="Uzima Healthcare" className="h-8" />
                <span className="text-xl font-bold text-blue-700 tracking-tight">Patient Portal</span>
            </div>
            {/* Center: Search */}
            <div className="flex-1 flex justify-center">
                <input
                    type="text"
                    placeholder="Search..."
                    className="w-full max-w-md px-4 py-2 rounded-xl border border-gray-200 bg-gray-50 focus:ring-2 focus:ring-blue-200 focus:border-blue-400 text-gray-700 shadow-sm"
                />
            </div>
            {/* Right: Notifications & Avatar */}
            <div className="flex items-center gap-4">
                {/* Notification Dropdown */}
                <div className="relative" ref={notifRef}>
                    <button onClick={() => setNotifOpen((v) => !v)} className="relative p-2 rounded-full bg-blue-50 hover:bg-blue-100 transition-colors">
                        <i className="ri-notification-3-line text-2xl text-blue-500"></i>
                        <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">0</span>
                    </button>
                    {notifOpen && (
                        <div className="absolute right-0 mt-2 w-72 bg-white rounded-xl shadow-lg z-50 p-4">
                            <div className="font-semibold text-gray-700 mb-2">Notifications</div>
                            <div className="text-gray-500 text-sm">No new notifications.</div>
                        </div>
                    )}
                </div>
                {/* Profile Dropdown */}
                <div className="relative" ref={profileRef}>
                    <button onClick={() => setProfileOpen((v) => !v)} className="flex items-center gap-2 bg-blue-50 px-3 py-1 rounded-xl hover:bg-blue-100">
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/users/${avatar}`}
                            alt="Avatar"
                            className="w-8 h-8 rounded-full border-2 border-blue-200 shadow"
                        />
                        <span className="font-medium text-blue-700 text-sm">{fname}</span>
                        <i className="ri-arrow-down-s-line text-blue-400"></i>
                    </button>
                    {profileOpen && (
                        <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg z-50 p-4">
                            <div className="flex items-center gap-3 mb-4">
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/images/users/${avatar}`}
                                    alt="Avatar"
                                    className="w-10 h-10 rounded-full border-2 border-blue-200 shadow"
                                />
                                <div>
                                    <div className="font-semibold text-gray-900">{fname}</div>
                                    <div className="text-xs text-gray-500">Patient</div>
                                </div>
                            </div>
                            <Link to="/patient/dashboard/profile" className="block px-2 py-2 rounded hover:bg-blue-50 text-gray-700 font-medium mb-1">
                                <i className="ri-user-3-line mr-2 text-blue-400"></i> Profile
                            </Link>
                            <Link to="/patient/dashboard/settings/preferences" className="block px-2 py-2 rounded hover:bg-blue-50 text-gray-700 font-medium mb-1">
                                <i className="ri-settings-3-line mr-2 text-blue-400"></i> Settings
                            </Link>
                            <button className="block w-full text-left px-2 py-2 rounded hover:bg-red-50 text-red-500 font-medium mt-2">
                                <i className="ri-logout-box-r-line mr-2"></i> Log Out
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )

}

export default PatientDashboardHeader